import React from "react";
import { useCallback } from "react";
import { useParams } from "react-router";
import { useHistory } from "react-router";
import Paper from "@material-ui/core/Paper";
import { Theme } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import makeStyles from "@material-ui/core/styles/makeStyles";
import SchoolForm from "../../components/admin/SchoolForm";
import Loading from "../../../../components/Loading";
import Error from "../../../../components/Error";
import { createSchoolFormValidator } from "../../validators";
import arrayMutators from "final-form-arrays";
import { Form } from "react-final-form";
import { AdapterLink } from "../../../../components/Adopter";
import useSchoolQueries from "../../hooks/useSchoolQueries";
import { useSnackbar } from "notistack";
import { Routes } from "../../../../constants/routes";
import { mutateErrors } from "../../../../utils";
import { FORM_ERROR } from "final-form";
import { useQuery } from "react-query";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: 35,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      padding: 15,
    },
  },
}));

export function EditPage() {
  const classes = useStyles();
  const { fetchOne, fetchUpdate } = useSchoolQueries();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const params = useParams<{ id: string }>();
  const { isLoading, isFetching, isError, error, data } = useQuery<any>(
    "school_" + params.id,
    () => {
      return fetchOne(params.id);
    },
  );
  const update = useCallback(
    async (data) => {
      try {
        await fetchUpdate(data);
        history.push(`/0/${Routes.SCHOOLS}`);
        enqueueSnackbar("Success", { variant: "success" });
      } catch (e) {
        const { errors, message } = mutateErrors(e);
        enqueueSnackbar(message, { variant: "error" });
        return { [FORM_ERROR]: message, ...errors };
      }
    },
    [fetchUpdate],
  ); // eslint-disable-line react-hooks/exhaustive-deps

  if (isLoading || isFetching) return <Loading />;

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  return (
    <Container maxWidth="md" className={classes.container}>
      <Breadcrumbs>
        <AdapterLink to="/0">Home</AdapterLink>
        <AdapterLink to="/0/school">Schools</AdapterLink>
        <Typography color="textPrimary">Edit School</Typography>
      </Breadcrumbs>
      <Paper>
        <Form
          onSubmit={update}
          validate={createSchoolFormValidator}
          initialValues={data && data.data}
          mutators={{
            ...arrayMutators,
          }}
          component={SchoolForm}
        />
      </Paper>
    </Container>
  );
}

export default EditPage;
